import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICellEditorRendererAngularComp, ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellEditorRendererParams, ICellRendererParams } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { SowApiService } from 'src/app/core/api/sow-api.service';

@Component({
  selector: 'app-actions',
  standalone: true,
  imports: [],
  templateUrl: './actions.component.html',
  styleUrl: './actions.component.scss'
})
export class ActionsComponent implements ICellRendererAngularComp {
   private params: ICellRendererParams;

   constructor(
        private sowApiService: SowApiService,
        private translateService: TranslateService,
        private toastrService: ToastrService

    ) {}

  agInit(params: ICellRendererParams): void {
   this.params = params
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

onDeleteRow(): void {
    const rowData = this.params.node.data;

    // Call the API first
    this.sowApiService.deleteSow(rowData.id).subscribe({
        next: () => {
            this.params.api.applyTransaction({ remove: [rowData] });
           const message = this.translateService.instant("sow.form.delete")
           this.toastrService.success(message)
        },
       error:  () => {
           const message =  this.translateService.instant("sow.form.deleteError")
           this.toastrService.error(message)
        }
    });
}

}
